import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { withDefaultStyles } from '../../../utils/material-ui/hoc';
import { switchProject } from '../../tenant/actions/project';

class Tenants extends React.Component<any, any> {
  public render() {
    return (
      <div style={this.props.style}>
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Tenant name</TableCell>
                <TableCell>Domain</TableCell>
                <TableCell>Is Active</TableCell>
                <TableCell>Created by</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.app.projects.map(row => {
                return (
                  <TableRow key={row.id} onClick={this.switchProject(row.id)(row.Name)} hover={true}>
                    <TableCell><div>{row.Name}</div></TableCell>
                    <TableCell><div>{row.Subdomain}</div></TableCell>
                    <TableCell><div>{row.IsActive}</div></TableCell>
                    <TableCell><div>{row.CreatorID}</div></TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  }
  private switchProject = id => name => (event) => {
    this.props.dispatch(switchProject(this.props.authentication.session.id, id, name))
    this.props.history.push('/console/tenants/' + id);
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(Tenants)));



// WEBPACK FOOTER //
// ./src/sub-projects/tenants/containers/content.tsx